var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2438_25104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 1.05566C4.6005 1.05566 1.03857 9.50011 1.03857 9.50011C1.03857 9.50011 4.6005 17.9446 13.5001 17.9446C22.3997 17.9446 25.9617 9.50011 25.9617 9.50011C25.9617 9.50011 22.3997 1.05566 13.5001 1.05566Z",
    stroke: "#4F84F7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.7223C15.795 13.7223 17.6539 11.8328 17.6539 9.50005C17.6539 7.16728 15.795 5.27783 13.5 5.27783C11.205 5.27783 9.34619 7.16728 9.34619 9.50005C9.34619 11.8328 11.205 13.7223 13.5 13.7223Z",
    stroke: "#4F84F7",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2438_25104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f6d317318b3a55a5163f029d8ebb03fc.svg";
export { ForwardRef as ReactComponent };